// ============================================================================
// apps/web/src/lib/supabase.ts
// ----------------------------------------------------------------------------
// Client Supabase pour le front. Utilise la clé `anon` (publique, bridée par
// RLS). Pour les opérations admin (créer un user, reset password, etc.),
// passer par le Worker via `lib/worker.ts`.
// ============================================================================

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@magic/shared';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    'Variables VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY manquantes. ' +
      'Copie .env.example en .env à la racine et remplis-le.',
  );
}

export const supabase: SupabaseClient<Database> = createClient<Database>(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
